/* ============================================================================
   3D BUILDER  -  LIGHTING

   Done from outside the section, using the renderer and scene it publishes on
   window.__pmScene. Keeping it here means a 1400-line working configurator
   stays shut, and the numbers below are a two-second edit next time they need
   nudging.

   The scene ships with four lights created inside pm-home.liquid:

     0  HemisphereLight  white / dark ground
     1  DirectionalLight key    front-right-high
     2  DirectionalLight fill   back-left-low
     3  DirectionalLight rim    behind, and originally RED - 0xE4342F

   That red was the store's old accent colour. It survived the black-and-white
   redesign because the one pass that touched the lights only adjusted their
   INTENSITY, never their colour, so every model picked up a red wash down one
   side. All of them are forced white here.

   A fifth light is added: a faint, directionless ambient lift. The four
   originals are all directional or hemispherical, so anything facing away from
   them fell to pure black and the detail there was simply gone. Ambient raises
   only the floor of the image, which is the part that was too dark. Keep it
   low - push it far and the model goes flat, because ambient light casts no
   shadow and defines no form.

   NOTE: a grey platform mesh used to be added here to give the bike something
   to stand on. It has been removed. The pool of light painted behind the
   canvas in builder-style.css does the same job without putting a second
   object in the frame.
   ============================================================================ */
(function () {

  var INTENSITY = [0.58, 1.05, 0.44, 0.58];
  var EXPOSURE = 0.96;
  var AMBIENT = 0.30;
  var AMBIENT_NAME = 'pmFaintFill';
  var FLOOR_NAME = 'pmStageFloor';

  var applied = 0;

  function tune() {
    var S = window.__pmScene;
    var THREE = window.THREE;
    if (!S || !S.scene || !S.renderer || !THREE) return false;

    /* Clear the old platform if a cached copy of the previous script already
       added one this session. */
    var stale = S.scene.getObjectByName(FLOOR_NAME);
    if (stale) S.scene.remove(stale);

    var amb = S.scene.getObjectByName(AMBIENT_NAME);
    if (!amb && THREE.AmbientLight) {
      amb = new THREE.AmbientLight(0xffffff, AMBIENT);
      amb.name = AMBIENT_NAME;
      S.scene.add(amb);
    } else if (amb) {
      amb.intensity = AMBIENT;
    }

    var lights = [];
    S.scene.traverse(function (o) {
      if (o.isLight && o.name !== AMBIENT_NAME) lights.push(o);
    });
    if (lights.length < 4) return false;

    for (var i = 0; i < lights.length; i++) {
      var L = lights[i];
      /* Hemisphere is skipped: its two colours are a sky/ground pair that is
         already neutral, and flattening them to white would kill the subtle
         top-down gradient. */
      if (L.color && !L.isHemisphereLight) L.color.setHex(0xffffff);
      if (INTENSITY[i] !== undefined) L.intensity = INTENSITY[i];
    }

    if (THREE.ACESFilmicToneMapping !== undefined) {
      S.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      S.renderer.toneMappingExposure = EXPOSURE;
    }

    applied++;
    return true;
  }

  var ticks = 0;
  var timer = window.setInterval(function () {
    ticks++;
    tune();
    if (applied >= 6 || ticks > 90) window.clearInterval(timer);
  }, 400);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pm-sw')) {
      window.setTimeout(tune, 60);
    }
  });

  /* Live tuning from the console:
       __pmLight.set([0.58, 1.05, 0.44, 0.58], 0.96)
       __pmLight.ambient(0.45) */
  window.__pmLight = {
    apply: tune,
    set: function (arr, exposure) {
      if (arr) INTENSITY = arr;
      if (exposure) EXPOSURE = exposure;
      applied = 0;
      return tune();
    },
    ambient: function (v) {
      if (typeof v === 'number') AMBIENT = v;
      applied = 0;
      return tune();
    }
  };
})();
